import PropTypes from 'prop-types';
import React from 'react';

import { Chip } from '@mui/material';
import classnames from 'classnames';

const MaterialChip = (props) => {
  const { variant = 'default', label, clickable, avatar, deleteIcon, onDelete, disabled, icon, size, ...rest } = props;

  return (
    <Chip
      {...props}
      className={classnames(MaterialChip.displayName)}
      clickable={clickable}
      avatar={avatar}
      deleteIcon={deleteIcon}
      onDelete={onDelete}
      disabled={disabled}
      icon={icon}
      size={size}
      label={label}
      variant={variant}
      {...rest}
    />
  );
};

MaterialChip.displayName = 'MaterialChip';

MaterialChip.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  variant: PropTypes.string,
};

export default MaterialChip;
